const saturate = {
    name: "saturate",
    path: "/saturate",
    title: "saturate",
    description: "Utilities for applying saturate filter effects to elements.",
    value: {
        'filter': {
            'saturate-<number>': 'saturate(<number>%)'
        },
    },
    exampleData: [
        {
            "title": "saturate-50, saturate-100",
            "description": "to control an element's saturate:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-4 gap-10 !bg-none !border-0 pt-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg saturate-50",
                        "text": "saturate-50",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg saturate-100",
                        "text": "saturate-100",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg saturate-125",
                        "text": "saturate-125",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-24 mx-auto rounded-lg saturate-200",
                        "text": "saturate-200",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                ],
                "className": "relative",
                "code": `<img class="saturate-50" src="/img/mountains.jpg" />
<img class="saturate-100" src="/img/mountains.jpg" />
<img class="saturate-125" src="/img/mountains.jpg" />
<img class="saturate-200" src="/img/mountains.jpg" />`
            }
        }
    ]
};

export default saturate;